module.exports = __webpack_public_path__ + "media/images/logos/vr_logo-0c7dcafb2f0597e5fec887bd3f0bfced.svg";